import React from "react";
import {useEffect, useRef} from "react";
// import CustomLoaderSmall from "../../components/Layout/CustomLoaderSmall";
import ChatMessageItem from "./ChatMessageItem";
import {useParams} from "react-router-dom";
import BoltCustomLoader from "../../../../components/Layout/BoltCustomLoader";
import {
    useGetPlayWrightQuerybyIdQuery,
} from "../../../../features/playwrightApiSlice";


export function ChatMessageList({ messages, inProgressMessage, noMessagesContent, showSources = false, onSpeakHandler,
                                    onPause, onResume, onStop, isPlaying, isPaused }:
                                {   messages: any,
                                    inProgressMessage: any,
                                    noMessagesContent: any,
                                    showSources?: boolean,
                                    onSpeakHandler?: (text: string) => void,
                                    onPause?: () => void,
                                    onResume?: () => void,
                                    onStop?: () => void,
                                    isPlaying?: boolean,
                                    isPaused?: boolean,
                                    }) {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const container = containerRef.current;
        if (container) container.scrollTop = container.scrollHeight;
    }, [messages, inProgressMessage]);

    const isEmpty = !messages?.some((m: any) => m.role && m.text?.trim());

    const {id: playWrightQueryId} = useParams();
    const {data: queryInfo} = useGetPlayWrightQuerybyIdQuery(playWrightQueryId);

    const azureBlobName = queryInfo?.originalFileName;

    return (
        <div className="flex-1 overflow-y-auto p-2" ref={containerRef}>

            <h2 className={"text-xs text-gray-800 font-medium"}>{azureBlobName}</h2>

            {messages?.map((m: any, idx: number) => (
                <ChatMessageItem
                    key={idx}
                    message={m}
                    showSources={showSources}
                    onSpeak={onSpeakHandler}
                    inProgress={inProgressMessage}
                    onPause={onPause}
                    onResume={onResume}
                    onStop={onStop}
                    isPlaying={isPlaying}
                    isPaused={isPaused}
                />
            ))}

            {inProgressMessage && (
                <>
                    <ChatMessageItem message={messages}
                                     showSources={showSources} inProgress={inProgressMessage}
                    />

                    <div className={"justify-center items-center py-20"}>
                        <BoltCustomLoader mode={"summary"} />
                    </div>
                </>
            )}
            {!inProgressMessage && isEmpty && (
                <div className="text-gray-900 text-center"> {noMessagesContent || ""}</div>
            )}
        </div>
    );
}